"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractDependencies = void 0;
const pi_syntax_tools_1 = require("@icg360/pi-syntax-tools");
const extractDependencies = (expression, thisContext) => {
    const dependencies = [];
    for (const path of (0, pi_syntax_tools_1.walkSyntax)(expression)) {
        if (path.type !== "path") {
            continue;
        }
        const identifier = path.items[0];
        if (identifier.type !== "identifier") {
            continue;
        }
        if (identifier.value === "this") {
            const thisProperty = path.items[1];
            if (thisProperty.type !== "property") {
                continue;
            }
            if (thisProperty.value === "term") {
                const termProperty = path.items[2];
                if (termProperty.type !== "property" || !thisContext.term) {
                    continue;
                }
                if (thisContext.iterable) {
                    dependencies.push({
                        type: "iterable-term",
                        iterableName: thisContext.iterable.name,
                        iterableIndex: -1, // -1 means it depends on the current instance
                        termName: thisContext.term.name,
                        property: termProperty.value,
                    });
                }
                else {
                    dependencies.push({
                        type: "term",
                        termName: thisContext.term.name,
                        property: termProperty.value,
                    });
                }
                continue;
            }
            if (thisProperty.value === "terms") {
                const termName = path.items[2];
                const termProperty = path.items[3];
                if (termName.type !== "property" ||
                    termProperty.type !== "property" ||
                    !thisContext.iterable) {
                    continue;
                }
                dependencies.push({
                    type: "iterable-term",
                    iterableName: thisContext.iterable.name,
                    iterableIndex: -1, // -1 means it depends on the current instance
                    termName: termName.value,
                    property: termProperty.value,
                });
                continue;
            }
            if (thisProperty.value === "iterable") {
                const iterableProperty = path.items[2];
                if (iterableProperty.type !== "property" || !thisContext.iterable) {
                    continue;
                }
                if (iterableProperty.value === "instances") {
                    const iterableIndex = path.items[3];
                    const instanceProperty = path.items[4];
                    const termName = path.items[5];
                    const termProperty = path.items[6];
                    if (iterableIndex.type !== "predicate" ||
                        instanceProperty.type !== "property" ||
                        termName.type !== "property" ||
                        termProperty.type !== "property") {
                        continue;
                    }
                    dependencies.push({
                        type: "iterable-term",
                        iterableName: thisContext.iterable.name,
                        iterableIndex: iterableIndex.expression.type === "number"
                            ? iterableIndex.expression.value
                            : Infinity, // Infinity means it depends on all the instances
                        termName: termName.value,
                        property: termProperty.value,
                    });
                    continue;
                }
                if (iterableProperty.value === "lists") {
                    const listType = path.items[3];
                    const termName = path.items[4];
                    const termProperty = path.items[5];
                    if (listType.type !== "property" ||
                        termName.type !== "property" ||
                        termProperty.type !== "property") {
                        continue;
                    }
                    if (listType.value === "terms") {
                        dependencies.push({
                            type: "iterable-term",
                            iterableName: thisContext.iterable.name,
                            iterableIndex: Infinity, // Infinity means it depends on all the instances
                            termName: termName.value,
                            property: termProperty.value,
                        });
                    }
                    continue;
                }
                dependencies.push({
                    type: "iterable",
                    iterableName: thisContext.iterable.name,
                    property: iterableProperty.value,
                });
            }
            // ignore this.event, this.index, this.position
            continue;
        }
        if (identifier.value === "terms") {
            const [, termName, termProperty] = path.items;
            if (termName.type !== "property" || termProperty.type !== "property") {
                continue;
            }
            dependencies.push({
                type: "term",
                termName: termName.value,
                property: termProperty.value,
            });
            continue;
        }
        if (identifier.value === "iterables") {
            const [, iterableName, iterableProperty] = path.items;
            if (iterableName.type !== "property" ||
                iterableProperty.type !== "property") {
                continue;
            }
            if (iterableProperty.value === "instances") {
                const iterableIndex = path.items[3];
                const instanceProperty = path.items[4];
                const termName = path.items[5];
                const termProperty = path.items[6];
                if (iterableIndex.type !== "predicate" ||
                    instanceProperty.type !== "property" ||
                    termName.type !== "property" ||
                    termProperty.type !== "property") {
                    continue;
                }
                dependencies.push({
                    type: "iterable-term",
                    iterableName: iterableName.value,
                    iterableIndex: iterableIndex.expression.type === "number"
                        ? iterableIndex.expression.value
                        : Infinity, // Infinity means it depends on all the instances
                    termName: termName.value,
                    property: termProperty.value,
                });
                continue;
            }
            if (iterableProperty.value === "lists") {
                const listType = path.items[3];
                const termName = path.items[4];
                const termProperty = path.items[5];
                if (listType.type !== "property" ||
                    termName.type !== "property" ||
                    termProperty.type !== "property") {
                    continue;
                }
                if (listType.value === "terms") {
                    dependencies.push({
                        type: "iterable-term",
                        iterableName: iterableName.value,
                        iterableIndex: Infinity, // Infinity means it depends on all the instances
                        termName: termName.value,
                        property: termProperty.value,
                    });
                }
                continue;
            }
            dependencies.push({
                type: "iterable",
                iterableName: iterableName.value,
                property: iterableProperty.value,
            });
            continue;
        }
        // ignore key, phase, env, meta
    }
    return dependencies;
};
exports.extractDependencies = extractDependencies;
//# sourceMappingURL=extract-dependencies.js.map